var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceTrackingInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3V1m0 22v-2m5-14v0a4 4 0 0 0-4-4h-2.169A3.831 3.831 0 0 0 7 6.83v0a3.83 3.83 0 0 0 1.86 3.286l6.28 3.768A3.831 3.831 0 0 1 17 17.169v0A3.831 3.831 0 0 1 13.169 21H11a4 4 0 0 1-4-4v0",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceTrackingInactive);
export default __webpack_public_path__ + "static/media/finance-tracking-inactive.0763697009a6b6d3ef5dfbf8bee75e55.svg";
export { ForwardRef as ReactComponent };